import {gql} from 'graphql-tag';

export const getSupplierTrips = gql
    `query supplierTrips($orgId: String!, $operationId: String!, $startDate: DateTime!, $endDate: DateTime!){
        supplierTrips(filter: {
            orgId: $orgId,
            operationId: $operationId,
            startDate: $startDate,
            endDate: $endDate
        }){
            supplierTrips{
                supplierId
                supplierName
                count
                timeSeries {
                   timeGroup
                   count
                }
            }
        }
    }`;

export const getCustomerTrips = gql
    `query customerTrips($orgId: String!, $operationId: String!, $startDate: DateTime!, $endDate: DateTime!){
        customerTrips(filter: {
            orgId: $orgId,
            operationId: $operationId,
            startDate: $startDate,
            endDate: $endDate
        }){
            customerTrips{
                customerId
                customerName
                count
                timeSeries {
                   timeGroup
                   count
                }
            }
        }
    }`;

export const getCustomerKilometers = gql
    `query GetCustomerKilometers($filter: CustomerKilometersFilterInput!) {
        customerKilometers(filter: $filter) {
            customers {
                customerId
                customerName
                totalKilometers
                vehicleData {
                    vehicleCategory
                    vehicleCategoryName
                    kilometers
                }
            }
        }
    }`;

export const getInvoiceFinancialData = gql
    `query getInvoiceFinancialData(
      $orgId: String!, 
      $operationId: String!,
      $startDate: DateTime!, 
      $endDate: DateTime!, 
      $type: FinancialType!, 
      $periodType: PeriodType = ONE_MONTH
    ) {
      getInvoiceFinancialData(
        input: {
          orgId: $orgId,
          operationId: $operationId,
          startDate: $startDate,
          endDate: $endDate,
          type: $type,
          periodType: $periodType
        }
      ) {
        groups {
          period
          startDate
          endDate
          total
        }
        total
        percentageChange
      }
    }`;

    export const getTotalValuePerKmOrShipment = gql
    `query getTotalValuePerKmOrShipment(
      $orgId: String!,
      $operationId: String!,
      $startDate: DateTime!,
      $endDate: DateTime!,
      $type: ValuePerType!,
      $periodType: PeriodType = ONE_MONTH
    ) {
      getTotalValuePerKmOrShipment(
        input: {
          orgId: $orgId,
          operationId: $operationId,
          startDate: $startDate,
          endDate: $endDate,
          type: $type,
          periodType: $periodType
        }
      ) {
        totalValue
        percentageChange
      }
    }`;

export const getCustomersMostProfiable = gql`
  query getCustomersMostProfiable($orgId: String!, $operationId: String!, $fromDate: DateTime!, $toDate: DateTime!, $pageSize: Float!) {
    getCustomersMostProfiable(orgId: $orgId, operationId: $operationId, fromDate: $fromDate, toDate: $toDate, pageSize: $pageSize) {
      customerId
      name
      totalRevenue
      percent
      icon
    }
  }
`;

export const getSupplierCostAnalysis = gql`
  query supplierCostAnalysis($filter: SupplierCostAnalysisFilterInput!) {
    supplierCostAnalysis(filter: $filter) {
      suppliers {
        supplierId
        supplierName
        totalCost
        tripCount
        percentageChange
        previousPeriodCost
      }
      timePeriod
      startDate
      endDate
      previousPeriodStartDate
      previousPeriodEndDate
    }
  }
`;

export const getUtilisationChartData = gql`
  query utilisationChartData($orgId: String!, $operationId: String!, $startDate: DateTime!, $endDate: DateTime!) {
    utilisationChartData(
      orgId: $orgId,
      operationId: $operationId,
      startDate: $startDate,
      endDate: $endDate
    ) {
      label
      average
      change
      isPositive
      chartData {
        timestamp
        value
        groupIndex
      }
    }
  }
`;

export const getSupplierList = gql`
  query supplierList($filter: SupplierListFilterInput!) {
    supplierList(filter: $filter) {
      suppliers {
        supplierId
        count
      }
    }
  }
`;

export const getSupplierTimeSeries = gql`
  query supplierTimeSeries($filter: SupplierTimeSeriesFilterInput!) {
    supplierTimeSeries(filter: $filter) {
      supplierId
      count
      timeSeries {
        timeGroup
        count
      }
    }
  }
`;

export const getTimeInsightsData = gql`
  query getTimeInsightsData(
    $orgId: String!,
    $operationId: String!,
    $startDate: DateTime!,
    $endDate: DateTime!,
    $periodType: PeriodType = ONE_MONTH
  ) {
    timeInsights(
      input: {
        orgId: $orgId,
        operationId: $operationId,
        startDate: $startDate,
        endDate: $endDate,
        periodType: $periodType
      }
    ) {
      financial {
        revenue {
          groups {
            period
            startDate
            endDate
            total
          }
          total
          percentageChange
        }
        cost {
          groups {
            period
            startDate
            endDate
            total
          }
          total
          percentageChange
        }
        profit {
          groups {
            period
            startDate
            endDate
            total
          }
          total
          percentageChange
        }
      }
      metrics {
        costPerKm {
          totalValue
          percentageChange
        }
        costPerShipment {
          totalValue
          percentageChange
        }
        revenuePerKm {
          totalValue
          percentageChange
        }
        revenuePerShipment {
          totalValue
          percentageChange
        }
        profitPerKm {
          totalValue
          percentageChange
        }
        profitPerShipment {
          totalValue
          percentageChange
        }
      }
      metadata {
        executionTime
        cacheHit
        dataFreshness
        queryComplexity
      }
    }
  }
`;

export const getJobSummary = gql`
  query getJobSummary($input: JobSummaryInput!) {
    jobSummary(input: $input) {
      completedJobs {
        jobName
        jobReferenceId
        loadReferenceId
        createdDateTime
        jpmId
        customerName
        status
        vehicleIds
        distance
        duration
        urlVersion
        jobType
        jobFileChain
        suppliers
        driver
        durationMinutes
      }
      deliveryInProgressJobs {
        jobName
        jobReferenceId
        loadReferenceId
        createdDateTime
        jpmId
        customerName
        status
        vehicleId
        completionPercentage
        expectedEndTime
        urlVersion
        jobType
        jobFileChain
        suppliers
        driver
      }
      notifiedJobs {
        jobName
        jobReferenceId
        loadReferenceId
        createdDateTime
        jpmId
        customerName
        status
        driver
        vehicle
        expectedStartTime
        urlVersion
        jobFileChain
        jobType
        suppliers
      }
      contractedJobs {
        jobName
        jobReferenceId
        loadReferenceId
        createdDateTime
        jpmId
        customerName
        status
        driverName
        vehicle
        urlVersion
        jobFileChain
        jobType
        customerContractId
        estimatedDistance
        estimatedDurationMinutes
        locationsCount
      }
      plannedJobs {
        jobName
        jobReferenceId
        loadReferenceId
        createdDateTime
        jpmId
        customerName
        status
        vehicleId
        distance
        duration
        urlVersion
        jobType
        jobFileChain
      }
      loadAssignmentJobs {
        jobName
        jobReferenceId
        loadReferenceId
        createdDateTime
        jpmId
        customerName
        status
        estimatedDistance
        estimatedDurationMinutes
        locationsCount
        urlVersion
        jobType
        jobFileChain
      }
      pendingAcceptanceJobs {
        jobName
        jobReferenceId
        loadReferenceId
        createdDateTime
        jpmId
        customerName
        status
        customerContractId
        suppliers
        requestType
        urlVersion
        jobType
        jobFileChain
      }
      acceptedJobs {
        jobName
        jobReferenceId
        loadReferenceId
        createdDateTime
        jpmId
        customerName
        status
        customerContractId
        suppliers
        costContractId
        urlVersion
        jobType
        jobFileChain
      }
      terminatedJobs {
        jobName
        jobReferenceId
        loadReferenceId
        createdDateTime
        jpmId
        customerName
        status
        suppliers
        driver
        vehicle
        terminatedBy
        terminatedAt
        urlVersion
        jobType
        jobFileChain
      }
      pagination {
        totalItems
        itemsPerPage
        currentPage
        totalPages
      }
      timeZone
      error
    }
  }
`;

export const getCustomerRevenue = gql`
  query getCustomerRevenue($input: CustomerRevenueInput!) {
    customerRevenue(input: $input) {
      customers {
        customerId
        totalRevenue
        previousTotalRevenue
        percentage
      }
      error
    }
  }
`;



